import { Loader2 } from "lucide-react";

export default function Loading() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-4 p-6">
        <Loader2 className="animate-spin text-gray-500" size={48} />
      </div>
    </div>
  );
}



